import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { RouterService } from '../router-service/router.service';
import { NamedRoutes } from '../router-service/route.constants';
import { TokenService } from '../token-service/token.service';
import { isAutoLoginRequest } from '@raptor-fe/core';

/**
 * A route guard that checks if a user is unauthenticated before granting access to a route.
 * If a valid token exists and no auto-login query params are present, the user is redirected
 * to the welcome screen, which performs the per-app, per-role landing routing (e.g. service
 * advisors land on the check-in search list). Auto-login requests bypass this check so the
 * login component can handle session cleanup and re-authentication.
 */
export const unauthenticatedGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const tokenService = inject(TokenService);
    const routerService = inject(RouterService);

    if (isAutoLoginRequest(route.queryParams)) {
        return true;
    }

    const value = tokenService.getToken();
    if (value) {
        routerService.navigateAndReplaceUrl(NamedRoutes.welcome());
        return false;
    } else {
        return true;
    }
};
